import React,{useState} from 'react';
import PhoneInput from 'react-phone-input-2';
import { Controller } from 'react-hook-form';
import 'react-phone-input-2/lib/style.css';

const CommonPhoneInput = ({
  name,
  label,
  changeCallback,
  control,
  errors,
  validationFn,
  requiredField,
  onCountryChange,
  errorFlag,
  errorStyle,
  isNextClicked,
  disabled =false,
  // phoneErrors,
  // setPhoneErrors
  
}) => {
  const [country,setCountry]=useState('')
  const [phoneErrors, setPhoneErrors] = useState("");
  const handlePhoneChange = (phoneValue, data, formOnChange) => {
    const phoneNumber = phoneValue?.replace(`+${data.dialCode}`, '')?.trim();
    const phoneWithoutCode = phoneValue.replace(new RegExp(`^${data.dialCode}\\s*`), "");
    formOnChange(phoneNumber);
    setCountry(data)
    if (onCountryChange) {
      onCountryChange(data);
    }
      if(phoneWithoutCode.length<10){
        changeCallback(true)
        setPhoneErrors("error")
      } else {
        changeCallback(false)
        setPhoneErrors("")
      }
  };

  return (
    <>
      {label && (
        <label htmlFor={name} className="mt-2 fw-bold">
          {label} {requiredField && <span className="required"> *</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          validate: (value) => {
            const { errorFlag, error } = validationFn({ 
              FieldName: name,
              value,
              country: country,
            });
            if (errorFlag) {
              return error;
            }
            return true;
          },
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <div class="mt-2"
              style={{
                width: '100%',
                alignItems: 'center',
                // marginLeft:'10px'
              }}
            >
              <PhoneInput
                defaultCountry="it"
                dropdownStyle={{}}
                containerStyle={{
                  width: 300,
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
                value={`+${value}`} 
                onChange={(phoneValue, data) =>
                  handlePhoneChange(phoneValue, data, onChange)
                }
                disabled={disabled}
                country="it"
                buttonStyle={{

                  width: 80,
                  borderTopLeftRadius: 40,
                  borderBottomLeftRadius: 40,
                  left: 0,
                }}
                inputStyle={{ width: 250 }}
                className={`phone-input-container ${
                  (errors?.[name]) && isNextClicked ? 'error' : ''} ${
                  disabled ? 'disabled-input' : ''}`}
                // ms-5
              />
            </div>
            { (!!phoneErrors)&& <small className="p-error">Contatto deve avere almeno 10 cifre</small>}
            {/* {(errors?.[name])&& <small className="p-error">{errorStyle ==true && errors[name].message }</small>} */}

          </>
        )}
      />
    </>
  );
};
// Object?.keys(errors)?.length ==0 && 
export default CommonPhoneInput;

